
import { Deferred } from 'src/utilities/deferred';

export type BotChallengeData = {
	map: number[];
	chars: string[];
}
export enum BotValidationMethod {
	NoBots = 'X-NoBots',
	Recaptcha = 'X-Recaptcha'
}

export type BotValidation = {
	method: BotValidationMethod;
	token: string;
}

export class BotProtection {
	private _challenge: BotChallengeData;
	private _botDetectedPromise = new Deferred<void>();
	private _humanDetectedPromise = new Deferred<void>();
	response: BotValidation;

	constructor(challenge: BotChallengeData) {
		this._challenge = challenge;
	}

	get challenge() {
		return this._challenge.map.map(i => this._challenge.chars[i]).join('');
	}

	get ifBotDetected() {
		return this._botDetectedPromise.promise;
	}

	get ifHumanDetected() {
		return this._humanDetectedPromise.promise;
	}

	botDetected() {
		this._botDetectedPromise.resolve();
	}

	isHuman(evidence: BotValidation) {
		this.response = evidence;
		this._humanDetectedPromise.resolve();
	}
}